import React, { useState, useEffect } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import brandLogo from 'assets/img/logos/widestnet-logo-black-transparent.png';

const NavbarStandard = () => {
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  // Handle hash scrolling after navigation
  useEffect(() => {
    if (location.hash) {
      const id = location.hash.replace('#', '');
      // Small delay to let the page render before scrolling
      const timer = setTimeout(() => {
        const el = document.getElementById(id);
        if (el) el.scrollIntoView({ behavior: 'smooth' });
      }, 100);
      return () => clearTimeout(timer);
    }
  }, [location]);

  const scrollTo = (e, id) => {
    e.preventDefault();
    const el = document.getElementById(id);
    if (el) {
      // We're on the landing page — just smooth scroll
      el.scrollIntoView({ behavior: 'smooth' });
    } else {
      // We're on a different page — navigate to landing with hash
      navigate(`/#${id}`);
    }
  };

  return (
    <nav className={`wn-navbar ${scrolled ? 'scrolled' : ''}`}>
      <Link to="/" className="wn-navbar-brand">
        <img src={brandLogo} alt="Widest Net Technologies" />
      </Link>
      <ul className="wn-navbar-links">
        <li>
          <a href="#about" onClick={e => scrollTo(e, 'about')}>
            About
          </a>
        </li>
        <li>
          <a href="#services" onClick={e => scrollTo(e, 'services')}>
            Services
          </a>
        </li>
        <li>
          <a href="#process" onClick={e => scrollTo(e, 'process')}>
            How It Works
          </a>
        </li>
        <li>
          <a href="#results" onClick={e => scrollTo(e, 'results')}>
            Results
          </a>
        </li>
        <li>
          <Link
            to="/demo"
            style={{ fontWeight: 600, color: 'var(--wn-primary)' }}
          >
            Demo Sandbox
          </Link>
        </li>
      </ul>
      <div className="wn-navbar-cta">
        <a
          href="#contact"
          className="wn-btn-primary"
          onClick={e => scrollTo(e, 'contact')}
        >
          Get Started
        </a>
      </div>
      <button className="wn-navbar-toggle" aria-label="Menu">
        <span />
        <span />
        <span />
      </button>
    </nav>
  );
};

export default NavbarStandard;
